/**
 * Checks if the offset background of given elements is affixed to the left and adjusts the element's left position accordingly.
 *
 * @param {Array<HTMLElement>} elements - The elements to check.
 * @param {Function} [widthCallback=null] - Optional callback function to run after setting the new position. It receives the current element and the total movement amount as arguments.
 * @param {string} [styleToSet='left'] - The style property to adjust. Defaults to 'left'.
 * @param {number} [belowBreakpoint=null] - Optional breakpoint width. If the window's inner width is less or equal to this value, the function will adjust the position of the elements. If null, it will adjust the position regardless of the window's width.
 */
function checkIfOffsetBackgroundIsAffixedLeft(
    elements,
    widthCallback = null,
    styleToSet = "left",
    belowBreakpoint = null
) {
    if (belowBreakpoint === null || window.innerWidth <= belowBreakpoint) {
        if (elements.length === 0) {
            return;
        }

        elements.forEach(function (element) {
            let rect = element.getBoundingClientRect();
            let moveAmount = 0 - rect.left; // Adjust the element's left position
            let totalMoveAmount = moveAmount;
            let currentLeft = element.style[styleToSet].replace("px", "");
            currentLeft = currentLeft === "" ? 0 : currentLeft;
            totalMoveAmount = parseInt(currentLeft) + moveAmount;
            element.style[styleToSet] = totalMoveAmount + "px";

            if (widthCallback !== null) {
                widthCallback(element, totalMoveAmount);
            }
        });
    }
}

function cmpDebounce(func, delay) {
    let timeoutId;
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, arguments);
        }, delay);
    };
}

// esbuild bundles each module's init.js as its own IIFE, so these helpers are
// not visible across bundles. Expose them on window (util.js is enqueued before
// its consumers) so the cta-section and alternated-cards bundles can use them.
window.checkIfOffsetBackgroundIsAffixedLeft = checkIfOffsetBackgroundIsAffixedLeft;
window.cmpDebounce = cmpDebounce;
